import React from "react";
import IconShow from "../helperComponents/Icon";
import footerStyle from "../../style/footer/Footer.module.css";
import { FaBrain } from "react-icons/fa";

const Footer = () => {
  return (
    <div className={`container ${footerStyle.footer_container}`}>
      <div className={`row ${footerStyle.footer_row_1}`}>
        <div className={`col-md-6 col-12 ${footerStyle.left_coloumn}`}>
          <div>
            <div className={`row ${footerStyle.l_col_row}`}>
              <div className={`col-12 ${footerStyle.footer_logo}`}>
                <img src="/assets/logos/moshiul.svg" alt="" />
              </div>
            </div>
            <div className={`row ${footerStyle.l_col_row}`}>
              <div className={`col-12`}>
                <h5 className={`${footerStyle.l_col_intro}`}>Software Engineer and Blockchain Researcher</h5>
                <h6 id={`${footerStyle.footerStacks}`}>NodeJS || ExpressJs || ReactJS || Laravel || Redis || MongoDB || MySQL || AWS || Hyperledger</h6>
              </div>
            </div>
          </div>
        </div>
        <div className={`col-md-6 col-12 ${footerStyle.right_coloumn}`}>
          <div className={`${footerStyle.contact_div}`}>
            <div className={`row ${footerStyle.r_col_row}`}>
              <div className={`col-12 ${footerStyle.right_coloumn_child_col}`}>
                <h4 id={`${footerStyle.contact}`}>Contact</h4>
              </div>
            </div>
            <div className={`row ${footerStyle.r_col_row} `}>
              <div id={`${footerStyle.right_coloumn_child_col}`} className={`col-12 ${footerStyle.right_coloumn_child_col}`}>
                <IconShow className={`${footerStyle.footer_icon}`} path="tel:+880 1631925038" src="assets/icons/footer-icons/whatsapp.svg" />
                <IconShow className={`${footerStyle.footer_icon}`} path="mailto:azammoshiul8@gmail.com" src="assets/icons/footer-icons/email.svg" />
                <IconShow
                  className={`${footerStyle.footer_icon}`}
                  path="https://bd.linkedin.com/in/moshiulazamm"
                  src="assets/icons/footer-icons/linkedin.svg"
                />
                <IconShow className={`${footerStyle.footer_icon}`} path="https://github.com/moshiul45" src="assets/icons/footer-icons/github.svg" />
                <IconShow
                  className={`${footerStyle.footer_icon}`}
                  path="https://scholar.google.com/citations?hl=en&user=aMUcKlsAAAAJ"
                  src="/assets/icons/footer-icons/scholar.svg"
                />
                <IconShow
                  className={`${footerStyle.footer_icon}`}
                  path="https://stackoverflow.com/users/19968600/azam45"
                  src="assets/icons/footer-icons/stackoverflow.svg"
                />
                <IconShow
                  className={`${footerStyle.footer_icon}`}
                  path="https://www.stopstalk.com/user/profile/azam45"
                  src="assets/icons/footer-icons/stopstalk.svg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`row ${footerStyle.footer_row_2}`}>
        <div className={`${footerStyle.col_12}`}>
          <h6 id={`${footerStyle.copyright}`}>
            © Copyright 2025. Made with <FaBrain /> by Moshiul
          </h6>
        </div>
      </div>
    </div>
  );
};

export default Footer;
